module.exports = __webpack_public_path__ + "img/05.4f3ca104.png";